export const nullableParseInt = (s: string | null) => (s ? parseInt(s, 10) : null ?? null); // second null is to prevent NaN

export const toFixedFloat = (val: number | string) =>
  +(typeof val === 'number' ? val : parseFloat(val)).toFixed(2);
